// AUTO-GENERATED by scripts/gen-build-info.js — do not edit by hand.
export const BUILD_INFO = {
  commit: "4f6bc19",
  branch: "HEAD",
  buildTime: "2026-11-05T15:23:12.392Z",
} as const;
